import { useCarrierEDIIntegration } from 'carrier/vehicles/data/VehiclesAPI';
import { useFlag } from 'shared/settings/FeatureToggles';

interface EdiSettingsAccess {
  isLoading: boolean;
  isVisible: boolean;
}

export function useEdiSettingsAccess(): EdiSettingsAccess {
  const isEdiSettingsEnabled = useFlag('ctms_edi_setup_vehicles');
  const { data, isLoading } = useCarrierEDIIntegration({
    enabled: isEdiSettingsEnabled,
  });

  return {
    isLoading,
    isVisible: !!data && data.setup_status !== 'not_submitted',
  };
}
